import { imageUrl } from "@/lib/api";
import { useCategories } from "@/hooks/useCategories";

export default function Categories({ onSelect }) {
  const { categories } = useCategories();
  const handle = (key) => {
    onSelect?.(key);
    document.getElementById("katalog")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="kategori" className="py-16 bg-[#FBF9F5] border-b border-[#E8E2D5]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs uppercase tracking-widest text-[#5F755E] font-semibold">
              Koleksi Lengkap
            </span>
            <h2 className="font-serif-display text-3xl font-normal text-[#1E2B1D] mt-1">
              Pilihan Kategori Bunga
            </h2>
          </div>
          <p className="text-xs text-[#6B7C66] max-w-sm">
            Semua kebutuhan karangan bunga mulai dari perayaan suka cita hingga ucapan duka cita
            kami sediakan dengan standar estetika tertinggi.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4">
          {categories.map((c) => (
            <button
              key={c.key}
              onClick={() => handle(c.key)}
              data-testid={`category-card-${c.key}`}
              className="group text-left rounded-2xl bg-[#F4EFE6] p-4 border border-[#E8E2D5] hover:border-[#3D5A40] transition-colors flex flex-col justify-between w-[calc(50%-0.5rem)] lg:w-[calc(25%-0.75rem)]"
            >
              <div className="aspect-square rounded-xl relative overflow-hidden mb-3">
                <img
                  src={imageUrl(c.image_url)}
                  alt={c.label}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {c.tag && (
                  <span className="absolute bottom-3 left-3 text-[11px] font-medium text-[#2E3C2C] bg-[#FBF9F5]/90 px-2.5 py-1 rounded-full backdrop-blur-sm">
                    {c.tag}
                  </span>
                )}
              </div>
              <div>
                <h3 className="font-serif-display text-base font-bold text-[#1E2B1D] group-hover:text-[#3D5A40] transition-colors">
                  {c.label}
                </h3>
                <p className="text-xs text-[#6B7C66] mt-1">{c.desc}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
